import { MerchantPaymentMethodDto } from "./merchantPaymentMethod.dto";
import { PaymentMethodDto } from "./paymentMethod.dto";

export interface PaymentMethodMerchantDto extends PaymentMethodDto {
  merchantPaymentMethods?: MerchantPaymentMethodDto[];
  merchantPaymentMethod?: MerchantPaymentMethodDto;
}